import React, { useEffect, useRef, useState } from "react";

import { Link } from "react-router-dom";
import { dataListsType } from "../shared/type";

const TrendingNow: React.FC<{
  latestPostsData: dataListsType[];
  className?: string;
  isShow?: boolean;
}> = ({ latestPostsData, className, isShow }) => {
  const titleRef = useRef<HTMLHeadingElement>(null);
  const [isTitleVisible, setIsTitleVisible] = useState(false);
  const itemRefs = useRef<(HTMLAnchorElement | null)[]>([]);
  const [itemVisibleStates, setItemVisibleStates] = useState<boolean[]>(
    new Array(latestPostsData.length).fill(false)
  );

  useEffect(() => {
    // Observe title
    if (titleRef.current) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsTitleVisible(true);
            observer.unobserve(titleRef.current!);
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(titleRef.current);
      return () => observer.disconnect();
    }
  }, []);

  useEffect(() => {
    // Observe each item
    const observers: IntersectionObserver[] = [];
    itemRefs.current.forEach((ref, index) => {
      if (!ref) return;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setItemVisibleStates((prev) => {
              const newStates = [...prev];
              newStates[index] = true;
              return newStates;
            });
            observer.unobserve(ref);
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(ref);
      observers.push(observer);
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, [latestPostsData.length]);

  return (
    <>
      {/* Trending Now */}
      <div className={`text-white space-y-4 w-full ${className}`}>
        <h1
          ref={titleRef}
          className={`flex ${
            isShow
              ? "justify-center lg:text-5xl text-4xl "
              : "xl:text-4xl text-3xl "
          } items-center gap-x-1 fade-in-section ${
            isTitleVisible ? "fade-in-visible" : ""
          }`}
        >
          {/* <img src="/icon/hot.png" alt="hot" className="w-10 h-10" /> */}
          <b>Trending Now</b>
        </h1>
        <div
          className={`flex flex-col justify-center p-3 rounded-md ${
            isShow ? "w-full" : "bg-[#f4f1ecaa] max-w-[540px] "
          } backdrop-blur-md`}
        >
          {latestPostsData.map((item, index) => {
            const params = new URLSearchParams({
              id: String(item.id),
              category: item.category,
              slug: item.urlinform,
            });
            return (
              <Link
                ref={(el) => {
                  itemRefs.current[index] = el;
                }}
                target="_top"
                // to={{
                //   pathname: `/article`,
                //   // search: `?id=${item.id}&${item.category}/${item.urlinform}/`,
                //   search: params.toString(),
                // }}
                to={`/article/${item.urlinform}`}
                key={index}
                className={`pb-6 pt-3 last:pb-4 first:pt-0.5 fade-in-section ${
                  itemVisibleStates[index] ? "fade-in-visible" : ""
                } ${
                  index === latestPostsData.length - 1
                    ? "border-b-0"
                    : "border-b-[1px] border-[#a0a0a0]"
                } ${isShow ? "  border-[#ffffff]" : " "}`}
                style={{
                  transitionDelay: `${index * 0.1}s`,
                }}
              >
                <div className="flex items-center gap-x-4 w-full">
                  <div
                    className={` ${
                      isShow
                        ? "w-[136px] h-[98px] sm:w-52 sm:h-[128px] "
                        : "2xl:w-40 2xl:h-[108px] w-32 h-[88px]"
                    } pl-[2px] border-r-[1px] border-[#7c7c7c] flex-shrink-0`}
                  >
                    <img
                      src={item.images[0]}
                      alt={item.title}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="flex flex-col gap-y-2">
                    <h5
                      className={`font-semibold uppercase ${
                        isShow
                          ? "text-[#ffffff] sm:text-base text-sm"
                          : "text-[#303030] 2xl:text-base text-sm "
                      } `}
                    >
                      {item.category}
                    </h5>
                    <h6
                      className={`font-bold ${
                        isShow
                          ? "text-[#ffffff] md:text-2xl sm:text-lg text-sm"
                          : "text-black 2xl:text-lg xl:text-sm lg:text-sm text-sm lg:line-clamp-3"
                      }`}
                    >
                      {item.title}
                    </h6>
                    <span
                      className={`xl:text-sm text-xs font-semibold uppercase ${
                        isShow ? "text-[#ffffffaa]" : "text-[#8d8d8d]"
                      }`}
                    >
                      {item.nation}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default TrendingNow;
